import * as React from "react";
import styled from "styled-components";
import { useField } from "formik";
import { defaultCompare as naturalSort } from "logic/DefaultCompare";
import { Input, Button } from "components/bootstrap";
import { Select } from "components/common";
const StyledSelect = styled(Select)`
  flex: 1 1 auto;
  min-width: 0;
`;
const StyledButton = styled(Button)`
  flex: 0 0 auto;
  margin-left: 0.5rem;
  white-space: nowrap;
`;
function DataAdapterPicker({ onCreateClick, dataAdapters = [] }) {
  const [, { value, touched, error }, { setTouched, setValue }] = useField("data_adapter_id");
  const sortedAdapters = dataAdapters.map((adapter) => ({ value: adapter.id, label: `${adapter.title} (${adapter.name})` })).sort((a, b) => naturalSort(a.label.toLowerCase(), b.label.toLowerCase()));
  const errorMessage = touched ? error : "";
  return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "data-adapter-select",
      label: "Data Adapter",
      required: true,
      bsStyle: errorMessage ? "error" : void 0,
      labelClassName: "d-block mb-1",
      wrapperClassName: "d-block",
      formGroupClassName: "mb-3"
    },
    /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "row", alignItems: "center" } }, /* @__PURE__ */ React.createElement(
      StyledSelect,
      {
        placeholder: "Select a data adapter",
        clearable: false,
        options: sortedAdapters,
        onBlur: () => setTouched(true),
        onChange: (v) => setValue(v),
        value
      }
    ), /* @__PURE__ */ React.createElement(StyledButton, { type: "button", "aria-label": "Create Data Adapter", onClick: onCreateClick }, "Create Data Adapter")),
    /* @__PURE__ */ React.createElement("div", { className: `mb-1 ${errorMessage ? "text-danger" : "text-muted"}` }, errorMessage || "Select an existing data adapter")
  ));
}
export default DataAdapterPicker;
